
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[page]/[[...uri]]",
      function () {
        return require("private-next-pages/[page]/[[...uri]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[page]/[[...uri]]"])
      });
    }
  